(()=>{
  function init(){
    document.querySelectorAll('.mz-cro-reviews').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const items=[...root.querySelectorAll('.mz-revie__item')];
      const button=root.querySelector('.mz-cro-review-toggle');
      if(!button)return;
      items.forEach(item=>item.hidden=false);
      button.hidden=true;
      if(items.length<=3)return;
      const featured=items.find(item=>(item.querySelector('.mz-revie__comment')?.textContent.trim().length||0)>12)||items[0];
      featured.parentElement.prepend(featured);
      const rest=[featured,...items.filter(item=>item!==featured)].slice(3);rest.forEach(item=>item.hidden=true);
      button.hidden=false;button.onclick=()=>{const expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?button.dataset.less:button.dataset.more;rest.forEach(item=>item.hidden=!expanded);};
    });
    document.querySelectorAll('.mz-cro-recommendations').forEach(root=>{
      const rail=root.querySelector('.mz-cro-products');
      root.querySelectorAll('[data-direction]').forEach(button=>button.onclick=()=>{const direction=Number(button.dataset.direction);const end=rail.scrollWidth-rail.clientWidth;const target=direction>0&&rail.scrollLeft>=end-3?0:direction<0&&rail.scrollLeft<=3?end:rail.scrollLeft+direction*rail.clientWidth;rail.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
    });
  }
  document.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');if(!link)return;const hash=link.getAttribute('href');if(!['#mz-cro-summary','#reviews','#mz-cro-shipping','#mz-size-guide-anchor'].includes(hash))return;const target=document.getElementById(hash.slice(1));if(!target)return;const disclosure=target.tagName==='DETAILS'?target:target.closest('details');if(disclosure)disclosure.open=true;requestAnimationFrame(()=>target.scrollIntoView({block:'start',behavior:'auto'}));},true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(()=>{
function movePhotoNavigation(){
 if(!document.body.hasAttribute('data-mz-cro-pilot'))return;
 document.querySelectorAll('.m-main-product--media').forEach(root=>{
  const thumbnails=root.querySelector('.m-product-media--slider__thumbnails');
  const navigation=root.querySelector('.m-product-media--slider__navigation');
  if(!thumbnails||!navigation||navigation.parentElement===thumbnails)return;
  thumbnails.append(navigation);
  window.dispatchEvent(new Event('resize'));
 });
}
if(document.readyState==='complete')movePhotoNavigation();else window.addEventListener('load',movePhotoNavigation,{once:true});
document.addEventListener('shopify:section:load',()=>requestAnimationFrame(movePhotoNavigation));
})();


(()=>{
  function updateGolf(id){
    document.querySelectorAll('[data-golf-variant]').forEach(panel=>{panel.hidden=panel.dataset.golfVariant!==String(id||'');});
  }
  document.addEventListener('change',event=>{
    if(event.target.matches('product-info form input[name="id"]'))updateGolf(event.target.value);
  });
  document.addEventListener('variant:changed',event=>{
    const id=event.detail?.variant?.id;
    if(document.querySelector('[data-golf-variant="'+id+'"]'))updateGolf(id);
  });
})();
